import React from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, useSearchParams, useLocation} from "react-router-dom";

import PrintersManagePane from './PrintersManagePane'
import PrintersCostPane from './PrintersCostPane'
import PrinterReport from '../controls/PrinterReport';
import DetailedReport from '../controls/DetailedReport';
import { getPrintersDetailedColumns } from '../controls/GetDetailedColumns';
import ReportsFilter from '../controls/ReportsFilter';
import '../App.css';
import FilterCaption from '../controls/FilterCaption';
import { MANAGE_PATH, COST_PATH } from '../utils/constants'; 

const FullPrinters = (props) => {

    const [searchParams] = useSearchParams();
    let filterData = useSelector(state => state.reportFilter);

    const location = useLocation();

    let url = "/printer_ex";
    if (location.search)
    {
        url += location.search + '&';
    }
    else
    {
        url += '?';
    }
    url += "noStats=false&returnEmpty=false&sort=Pages DESC";
    
    return (
        <div className = "history-pane-header">
            <div className = "filter-report-picker"><ReportsFilter/></div>
            {location.search && <div className = "range-picker"><FilterCaption searchParams = {searchParams}/></div>}           
            <DetailedReport 
                api_url = {url} 
                columns = {getPrintersDetailedColumns()}
                filterData = {filterData}
            />
        </div>
    );
}

const PrintersPane = (props) => {  

    return (
        <div>
            <Routes>
                <Route path={"/"} element={<FullPrinters/>}/>
                <Route path=':id' element={<PrinterReport/>}/>
                <Route path={MANAGE_PATH} element={<PrintersManagePane/>}/>
                <Route path={COST_PATH} element={<PrintersCostPane/>}/>
            </Routes>
        </div>
        );
}

  
export default PrintersPane;